// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.remuneration {
  gap: 5px;
  flex-direction: column;
  display: flex;
  margin: 5px 0;
}

.remuneration-accordion {
  max-height: 34rem;
  overflow: auto;
}

.remuneration-tab-header {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 0.75rem;
}

.remuneration-tab-header-main {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  min-width: 0;
  flex: 1;
}

.remuneration-tab-index {
  font-size: 0.85rem;
  color: var(--tj-primary-gray-500);
  white-space: nowrap;
}

.remuneration-tab-summary {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.remuneration-tab-content {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.remuneration-row-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.remuneration-empty {
  color: var(--tj-primary-gray-500);
  margin: 0.5rem 0 1rem 0;
}

.company-provider-field {
  max-width: 26rem;
}

.company-product-list {
  display: grid;
  gap: 1rem;
}

.company-product {
  border: 1px solid var(--surface-border, #d1d5db);
  border-radius: 0.5rem;
  padding: 1rem;
}
.company-product h4 {
  margin: 0 0 0.75rem;
}

.company-default-rule,
.company-override-rule {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.company-override-rule {
  border-top: 1px dashed var(--surface-border, #d1d5db);
  margin-top: 1rem;
  padding-top: 1rem;
}

.rule-kind {
  color: var(--tj-primary-gray-500);
  font-size: 0.85rem;
  font-weight: 600;
}

.override-heading {
  align-items: center;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

.override-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.override-order-help {
  display: block;
  margin-top: 1rem;
}

@media (max-width: 991px) {
  .remuneration-accordion {
    max-height: none;
  }
  .remuneration-tab-summary {
    white-space: normal;
  }
}
/*# sourceMappingURL=data:application/json;base64,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 */`, "",{"version":3,"sources":["webpack://./projects/app-ui/src/app/admin/pages/invoicing/invoice/remuneration-accordion/remuneration-accordion.component.scss"],"names":[],"mappings":"AAAA;EACI,QAAA;EACA,sBAAA;EACA,aAAA;EACA,aAAA;AACJ;;AAEA;EACI,iBAAA;EACA,cAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,OAAA;AACJ;;AAEA;EACI,kBAAA;EACA,iCAAA;EACA,mBAAA;AACJ;;AAEA;EACI,mBAAA;EACA,gBAAA;EACA,uBAAA;AACJ;;AAEA;EACI,aAAA;EACA,sBAAA;EACA,YAAA;AACJ;;AAEA;EACI,aAAA;EACA,yBAAA;EACA,WAAA;EACA,eAAA;AACJ;;AAEA;EACI,iCAAA;EACA,uBAAA;AACJ;;AAEA;EACI,gBAAA;AACJ;;AAEA;EACI,aAAA;EACA,SAAA;AACJ;;AAEA;EACI,gDAAA;EACA,qBAAA;EACA,aAAA;AACJ;AACI;EACI,mBAAA;AACR;;AAGA;;EAEI,aAAA;EACA,sBAAA;EACA,WAAA;AAAJ;;AAGA;EACI,qDAAA;EACA,gBAAA;EACA,iBAAA;AAAJ;;AAGA;EACI,iCAAA;EACA,kBAAA;EACA,gBAAA;AAAJ;;AAGA;EACI,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,eAAA;EACA,SAAA;AAAJ;;AAGA;EACI,aAAA;EACA,eAAA;EACA,WAAA;AAAJ;;AAGA;EACI,cAAA;EACA,gBAAA;AAAJ;;AAGA;EACI;IACI,gBAAA;EAAN;EAGE;IACI,mBAAA;EADN;AACF;AACA,opIAAopI","sourcesContent":[".remuneration {\n    gap: 5px;\n    flex-direction: column;\n    display: flex;\n    margin: 5px 0;\n}\n\n.remuneration-accordion {\n    max-height: 34rem;\n    overflow: auto;\n}\n\n.remuneration-tab-header {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 0.75rem;\n}\n\n.remuneration-tab-header-main {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    min-width: 0;\n    flex: 1;\n}\n\n.remuneration-tab-index {\n    font-size: 0.85rem;\n    color: var(--tj-primary-gray-500);\n    white-space: nowrap;\n}\n\n.remuneration-tab-summary {\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.remuneration-tab-content {\n    display: flex;\n    flex-direction: column;\n    gap: 0.75rem;\n}\n\n.remuneration-row-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.5rem;\n    flex-wrap: wrap;\n}\n\n.remuneration-empty {\n    color: var(--tj-primary-gray-500);\n    margin: 0.5rem 0 1rem 0;\n}\n\n.company-provider-field {\n    max-width: 26rem;\n}\n\n.company-product-list {\n    display: grid;\n    gap: 1rem;\n}\n\n.company-product {\n    border: 1px solid var(--surface-border, #d1d5db);\n    border-radius: 0.5rem;\n    padding: 1rem;\n\n    h4 {\n        margin: 0 0 0.75rem;\n    }\n}\n\n.company-default-rule,\n.company-override-rule {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.company-override-rule {\n    border-top: 1px dashed var(--surface-border, #d1d5db);\n    margin-top: 1rem;\n    padding-top: 1rem;\n}\n\n.rule-kind {\n    color: var(--tj-primary-gray-500);\n    font-size: 0.85rem;\n    font-weight: 600;\n}\n\n.override-heading {\n    align-items: center;\n    display: flex;\n    justify-content: space-between;\n    flex-wrap: wrap;\n    gap: 1rem;\n}\n\n.override-actions {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 0.5rem;\n}\n\n.override-order-help {\n    display: block;\n    margin-top: 1rem;\n}\n\n@media (max-width: 991px) {\n    .remuneration-accordion {\n        max-height: none;\n    }\n\n    .remuneration-tab-summary {\n        white-space: normal;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
